import { LandedCostSettingsSchema } from "@redotech/redo-model/landed-cost/landed-cost-settings";
import * as z from "zod/v4";

export const getLandedCostSettings = {
  name: "getLandedCostSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ landedCost: LandedCostSettingsSchema.optional() }),
};
